<template>
    <div class="header">我是一个公共头</div>
</template>
<script>
    export default {
        name: "app-header",
        data() {
            return {
                //------
            }
        },
        created() {
        }
    }
</script>
<style lang="scss" scoped></style>
